import { render, staticRenderFns } from "./p-importer.vue?vue&type=template&id=966cbdd8&"
import script from "./p-importer.vue?vue&type=script&lang=js&"
export * from "./p-importer.vue?vue&type=script&lang=js&"
import style0 from "./p-importer.vue?vue&type=style&index=0&id=966cbdd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports